// extracted by mini-css-extract-plugin
module.exports = {"container":"_3s4Yl-","placeholder-img":"_346RWG"};